import React  from 'react';
const ExternalWallet = () => {
    return ( <>
    External Wallet
    </> );
}
 
export default ExternalWallet;